if (!Date.prototype.getWithoutTime) {
    Date.prototype.getWithoutTime = function () {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate());
    };
}
//# sourceMappingURL=date.extensions.js.map